import React from 'react';

// Make hatTarget 'ref="hatTarget"'
// Add '.fill' to all body elements
// Add '.fill--face' to nose

class HeadHOC extends React.Component {
	componentDidMount() {
		this.props.getHatTargetCoords(this.refs.hatTarget);
	}
}

export default class Heads extends HeadHOC {
	render() {
		return (
			<g>
				<circle ref="hatTarget" cx="201.66981" cy="252.25842" />
				<g className="ear ear--right">
					<path className="fill fill--alt" fill="#F9CA8C" d="M207.12628,250.49135c0,0-4.68541-29.08371,5.70441-53.77675
						c7.47893-17.77489,26.79756-26.57507,37.0354-30.1109c3.71422-1.28279,7.75418,0.63651,9.0762,4.33693
						c2.37631,6.6514,3.04181,21.60115,2.41016,30.69572c-1.56705,22.56326-21.50287,46.37608-21.50287,46.37608" />
				</g>
				<g className="ear ear--left">
					<path className="fill fill--alt" fill="#F9CA8C" d="M197.61336,250.49135c0,0,4.68541-29.08371-5.70441-53.77675
						c-7.47893-17.77489-26.79758-26.57507-37.0354-30.1109c-3.71423-1.28279-7.75418,0.63651-9.07622,4.33693
						c-2.3763,6.6514-3.04179,21.60115-2.41016,30.69572c1.56706,22.56326,21.50288,46.37608,21.50288,46.37608" />
				</g>
				<path className="fill fill--alt" fill="#F9CA8C" d="M202.42819,223.74702c27.71442,0,40.42635,9.24236,49.70348,53.73799
					c3.55681,21.93875-12.68216,38.52969-30.85414,38.63864c-4.60289,0.02762-33.29839,0.0271-37.81541,0
					c-18.172-0.10895-34.41096-16.69989-30.85416-38.63864C162.05992,232.98938,174.71378,223.74702,202.42819,223.74702z" />
				<path className="fill--face nose" fill="#FC7E7E" d="M196.39325,288.02222l3.80586,4.64508
					c1.12845,1.37732,3.23416,1.38,4.36613,0.00558l3.82126-4.63968c0.54681-0.66394,0.02766-1.66891-0.82869-1.58844
					c-3.44424,0.32364-6.88844,0.32065-10.33269-0.00897C196.36932,286.35388,195.84837,287.35721,196.39325,288.02222z" />
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Bunny/Heads.js